import { Component } from '@angular/core';

@Component({
  selector: 'ava-expansion-panel-header',
  standalone: true,
  template: ` <ng-content /> `,
})
export class ExpansionPanelHeaderComponent {}
